import React from "react";
import AuthLayout from "../components/AuthLayout";
import FailureResponse from "../reusableComponents/components/generics/FailureResponse";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PORTAL } from "../utils/constant";

function FailureMessage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(PORTAL);
  };

  const handleBackButtonClick = () => {
    window.open(process.env.REACT_APP_IMS_URL);
  };
  return (
    <div>
      <AuthLayout
        imageTitle={t("titleCreateAccount")}
        imageSubtitle={t("subheadingCreateAccount")}
        buttonName={t("login")}
        accountMsg={t("alreadyAccount")}
        buttonClick={handleClick}
        backButtonClick={handleBackButtonClick}
      >
        <FailureResponse
          title={t("FailureTitle")}

        />
      </AuthLayout>
    </div>
  );
}

export default FailureMessage;
